import React, { useEffect, useState } from "react";
import { Box, Button, TextareaAutosize, Typography } from "@mui/material";
import dayjs from "dayjs";
import Calendar from "../calendar/Calendar";
import Cars from "../cars/Cars";
import TableData from "../table/TableData";
import UploadImg from "../uploadImage/UploadImg";
import axios from "axios";
import { url } from "../../utils/url";
import { defaultRows } from "../../utils/table";

const Driver = () => {
  const [userId, setUserId] = useState("");
  const [carId, setCarId] = useState("");
  const [date, setDate] = useState(dayjs(new Date()));
  const [rows, setRows] = useState(defaultRows);
  const [travelData, setTravelData] = useState(null);
  const [additinalInfo, setAdditionalInfo] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [savedChanges, setSavedChanges] = useState(false);
  const [error, setError] = useState(null);
  const [photoId, setPhotoId] = useState("");

  useEffect(() => {
    if (!carId) {
      return;
    }

    const dateIsoString = date.$d.toISOString();
    setTravelData(null);
    setRows(structuredClone(defaultRows));
    setSelectedImage(null);
    setPhotoId("");
    setSelectedImage(null);
    setAdditionalInfo("");
    setError(null);
    (async () => {
      try {
        const getUserIdRequest = await axios.get(`${url}who-am-i`, { withCredentials: true });
        const checkTravelRequest = await axios.get(`${url}travels/${dateIsoString}?vehicleId=${carId}`, { withCredentials: true });
        setUserId(getUserIdRequest.data.id);

        if (checkTravelRequest.data.length) {
          const getPhotoRequest = await axios.get(`${url}attached-files/travels/${checkTravelRequest.data[0].id}`, { withCredentials: true });

          if (getPhotoRequest.data.length) {
            setPhotoId(getPhotoRequest.data[0].id);
            setSelectedImage(getPhotoRequest.data[0]);
          }
          setRows(JSON.parse(checkTravelRequest.data[0].data));
          setTravelData(checkTravelRequest.data[0]);
         
        }
      } catch (err) {
        setError("Възникна проблем! Моля опитайте по-късно");
        console.log(err);
      }
    })();
  }, [carId, date]);

  const submitHandler = async () => {
    setError(null);
    let travel = {};

    if (travelData) {
      travel = {...travelData};
      travel.data = JSON.stringify(rows);
    } else {
      travel.userId = userId;
      travel.date = date.$d.toISOString();
      travel.vehicleId = carId;
      travel.data = JSON.stringify(rows);
    }

    if (additinalInfo) {
      travel.notes = additinalInfo;
    }

    try {
      if (travelData) {
        await axios.put(`${url}travels/${travelData.id}`, travel, { withCredentials: true });
        const travelId = await travelData.id;

        if (selectedImage && !selectedImage.id) {
          const formData = new FormData();
          formData.append("file", selectedImage);

          if (photoId) {
            await axios.put(`${url}attached-files/${photoId}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            });
          } else {
            await axios.post(`${url}attached-files/travels/${travelId}`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              withCredentials: true,
            });
          }
        }
      } else {
        const sendRowsRequest = await axios.post(`${url}travels`, travel, { withCredentials: true });
        const travelId = await sendRowsRequest.data.id;
        if (selectedImage) {
          const formData = new FormData();
          formData.append("file", selectedImage);

          await axios.post(`${url}attached-files/travels/${travelId}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          });
        }
      }

      setSavedChanges(true);
      setTimeout(() => {
        setSavedChanges(false);
      }, 3000);
    } catch (err) {
      setError("Възникна проблем! Моля опитайте по-късно");
      console.log(err);
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-evenly",
          alignItems: "center",
          marginBottom: "50px",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
        }}
      >
        <Calendar date={date} setDate={setDate} />
        <Cars setCarId={setCarId} />
      </Box>
      <TableData rows={rows} setRows={setRows} />
      <Box
        sx={{
          margin: "20px",
          width: {
            xs: "100%",
            lg: "605px",
          },
        }}
      >
        <TextareaAutosize placeholder="Допълнителна информация" value={additinalInfo} onChange={(e) => setAdditionalInfo(e.target.value)} />
      </Box>
      <UploadImg selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
      {savedChanges ? (
        <Typography align="center" color="green" paddingBottom="50px">
          Данните бяха запазени успешно
        </Typography>
      ) : (
        <Button sx={{ display: "block", margin: "100px auto" }} variant="contained" onClick={submitHandler} disabled={!carId}>
          Изпрати
        </Button>
      )}
      {error && (
        <Typography color="red" align="center" paddingBottom="50px">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Driver;
